import { render, staticRenderFns } from "./ModalDepositRecord.vue?vue&type=template&id=54ca18dc&"
import script from "./ModalDepositRecord.vue?vue&type=script&lang=js&"
export * from "./ModalDepositRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModalDepositRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports